// extracted by mini-css-extract-plugin
export default {"NormalNavigationActions":"normalNavigationActions_NormalNavigationActions__Yp+IH"};